
const VocabPatientContent = {
    'patients_section_id': ['patients', 'patients'],
    'patients_section_title': ['Pacientes', 'Patients'],

    'FAQ_section_id': ['faq', 'patients'],
    'FAQ_section_title': ['FAQ', 'patients'],

    'FAQ_Q1_id': ['faq_01', 'faq_01'],
    'FAQ_Q1_title': ['¿Qué es un expediente clínico?', 'What is a medical record?'],
    'FAQ_Q1_body': [
        'El expediente clínico es un registro completo y organizado de la información médica de un paciente, incluye datos personales, historial médico, hereditario, resultados de exámenes, tratamientos, entre otros. :)', 
        'TEST'
    ],

    'FAQ_Q2_id': ['faq_02', 'faq_02'],
    'FAQ_Q2_title': ['¿Para qué un expediente clínico?', 'FAQ'],
    'FAQ_Q2_body': [
        'Al contener toda tu información relevante, facilita a los profesionales conocer tu evolución clínica, ayudando así a una mejor interpretación y respuesta a tus síntomas generando tratamientos más certeros y eficaces.\nLa ley en México lo contempla como tu derecho, su contenido es de tu propiedad y es manejado por profesionales de la salud quienes se encargan de analizar, agregar, compartir y muy frecuentemente fungen como su resguarda', 
        'TEST'
    ],

    'FAQ_Q3_id': ['faq_03', 'faq_03'],
    'FAQ_Q3_title': ['¿Por qué MedCleir? ', 'FAQ'],
    'FAQ_Q3_body': [
        'Somos una compañía que te ofrece resguardar tu información y brindar acceso a los profesionales que tú decidas, por su parte a ellos les damos claridad y orden aunado a herramientas que facilitan el diagnóstico y generación de conocimiento en beneficio de todos.', 
        'TEST'
    ],
    'FAQ_Q4_id': ['faq_04', 'faq_04'],
    'FAQ_Q4_title': ['¿Qué gano yo?', 'FAQ'],
    'FAQ_Q4_body': [
        'Tiempo y dinero; al tener control sobre tu información evitarás empezar desde cero con cada especialista, brindamos transparencia y prevenimos tratamientos repetitivos.', 
        'TEST'
    ],
    
    'help_section_id': ['help', 'help'],
    'help_section_title': ['Ayuda', 'Help'],

    'privacy_section_id': ['privacy', 'privacy'],
    'privacy_section_title': ['Privacidad', 'Privacy'],

    'pricing_section_id': ['pricing', 'pricing'],
    'pricing_section_title': ['Precios', 'Pricing'],


    'plans_id': ['plans', 'plans'],


    'benefits_id': ['benefits', 'benefits'],


  }
  export default VocabPatientContent;
    